import { getCookie } from "cookies-next";
import { DispathHookUpdate } from "../../hooks";
import { FIELDS_LEAD_PIPEFY } from "../../hooks/pipefy/src/get-query";
import { SetLog, TagLogs } from "../../logs/set-log";
import { GetWLData } from "../../wl";
import { _SaveLead } from "./_SaveLead";
import { _FindLead } from "./_FindLead";
import { COOKIES_TAGS } from "../../../functions/cookies/COOKIES_TAGS";

export const _DispathSaveHookLead = async (dataLead, context) => {
  const dataLeadConfigured = getConfiguredDataLeadToHook(dataLead);

  const resultDispatchHooks = await DispathHookUpdate({
    body: dataLeadConfigured,
    pipeId: dataLead.pipe_id,
    req: context?.req,
    res: context?.res,
  }).catch((err) => {
    SetLog(TagLogs.error_dispath_hook_update, { msg: err.message }, false);
    return false;
  });

  let leadId;
  try {
    leadId = getCookie(COOKIES_TAGS.LEAD_ID, {
      req: context.req,
      res: context.res,
    });
  } catch (error) {}

  if (!leadId) {
    leadId = dataLead?.id;
  }

  if (leadId) {
    // obtendo retorno do pipefy, se houver
    const pipeResult = resultDispatchHooks?.filter(
      (item) => item.hook == "pipefy_lead_data"
    )?.[0];

    // Fallback - Caso haja erro
    if (!pipeResult?.status) {
      sendFallback(leadId, context);
    }

    // Caso novo pipe, salvar o id do card criado no lead
    if (pipeResult && pipeResult?.data?.createCard?.card?.id) {
      await _SaveLead(
        {
          id: leadId,
          pipe_id: pipeResult.data.createCard.card.id,
        },
        context
      );
    }
  }
  return resultDispatchHooks;
};

function getConfiguredDataLeadToHook(dataLead) {
  if (dataLead.tipo === "pf") {
    dataLead.tipo = "Para sua casa";
  } else if (dataLead.tipo === "pj") {
    dataLead.tipo = "Para seu negócio";
  }

  if (dataLead.json_form) {
    const json = JSON.stringify(dataLead.json_form);
    dataLead.json_form = `${json.replaceAll('"', "")}`;
  }

  const { id, ...rest } = dataLead;

  return rest;
}

async function sendFallback(leadId, context) {
  3;
  const lead = await _FindLead(context);

  if (!lead) {
    return false;
  }

  SetLog(
    TagLogs.error_create_card_pipefy_fallback,
    { msg: "Tratando o lead id: " + leadId },
    false
  );

  const dataLeadConfigured = {
    celular: phoneNumber,
    campanha_txt: resultSaveLead.data?.attributes?.campanha,
    assessor: resultSaveLead.data?.attributes?.assessor,
    municipio: `${resultSaveLead.data?.attributes?.municipio} - ${resultSaveLead.data?.attributes?.uf}`,
    valor_medio_mensal_da_conta: resultSaveLead.data?.attributes?.valor_consumo,
    concessionaria_texto: resultSaveLead.data?.attributes?.nome_concessionaria,
    usina_texto:
      resultSaveLead.data?.attributes?.usina?.data?.attributes
        ?.nome_sharpspring,
    disponibilidade_atendimento: "Sim", // Usuário não chega na tela caso contrário
    tipo: resultSaveLead.data?.attributes?.tipo,
    pipe_id: resultSaveLead.data?.attributes?.pipe_id,
  };

  const resultDispatchHooks = await DispathHookUpdate({
    body: dataLeadConfigured,
    pipeId: dataLead.pipe_id,
    req: context?.req,
    res: context?.res,
  }).catch((err) => {
    SetLog(TagLogs.error_dispath_hook_update, { msg: err.message }, false);
    return false;
  });

  return resultDispatchHooks;
}
